export interface InterfaceLanguage {
	/** ISO 639-1 language + ISO 3166-1 region, same as the .NET culture name */
	code: string;
	/** Name written in the language itself */
	name: string;
}

export const DEFAULT_INTERFACE_LANGUAGE = 'en-US';

const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];

/** Whether the language (`ar-EG`, `ar`...) is written right to left */
export function isRtlLanguage(code: string | null | undefined): boolean {
	return !!code && RTL_LANGUAGES.includes(code.trim().replace('_', '-').toLowerCase().split('-')[0]);
}

export const INTERFACE_LANGUAGES: InterfaceLanguage[] = [
	{ code: 'ar-EG', name: 'العربية' },
	{ code: 'de-DE', name: 'Deutsch' },
	{ code: 'en-US', name: 'English (US)' },
	{ code: 'es-ES', name: 'Español' },
	{ code: 'fr-FR', name: 'Français' },
	{ code: 'hi-IN', name: 'हिन्दी' },
	{ code: 'it-IT', name: 'Italiano' },
	{ code: 'ja-JP', name: '日本語' },
	{ code: 'ru-RU', name: 'Русский' },
	{ code: 'tr-TR', name: 'Türkçe' },
	{ code: 'zh-CN', name: '简体中文' },
	{ code: 'zh-TW', name: '繁體中文' }
];

/**
 * Maps any language tag (`fr`, `fr-ca`, `zh-Hant-TW`, `en_us`...) to the closest supported code.
 * Returns null when nothing matches.
 */
export function normalizeInterfaceLanguage(value: string | null | undefined): string | null {
	if (!value) {
		return null;
	}

	const tag = value.trim().replace('_', '-').toLowerCase();

	const exact = INTERFACE_LANGUAGES.find(l => l.code.toLowerCase() === tag);
	if (exact) {
		return exact.code;
	}

	if (tag.startsWith('zh')) {
		const traditional = /hant|-tw|-hk|-mo/.test(tag);
		return traditional ? 'zh-TW' : 'zh-CN';
	}

	const language = tag.split('-')[0];
	const sameLanguage = INTERFACE_LANGUAGES.find(l => l.code.toLowerCase().split('-')[0] === language);
	return sameLanguage ? sameLanguage.code : null;
}
